import { Locale } from 'date-fns'
import i18next from 'i18next'

import { LOCALES } from '../constants/locales'

export function getLocale(): Locale {
  const lang = (i18next.language || 'pt') as keyof typeof LOCALES
  return LOCALES[lang] || LOCALES.pt
}
